// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"T0-z"};